import React, { useId } from 'react';
import { Input } from '../components/Formik/Input/Input';
import { MultipleChoice } from '../components/Formik/MultipleChoice/MultipleChoice';
import { Select } from '../components/Formik/Select/Select';
import { Checkbox } from '../components/Formik/Checkbox/Checkbox';
import { Radio } from '../components/Formik/Radio/Radio';
import { TextArea } from '../components/Formik/TextArea/TextArea';
import { MarkdownWrapper } from '../components/Styled/FormDescription';
import { Number } from '../components/Formik/Number/Number';

const componentMap = {
  'form.input': Input,
  'form.checkbox': Checkbox,
  'form.multiple-choice': MultipleChoice,
  'form.select': Select,
  'form.radio': Radio,
  'form.text-area': TextArea,
  'form.number': Number,
};

export const FormikComponent = (item) => {
  const cmsComponent = item.__component;
  const id = useId();

  // ReactMarkdown needs to have it's content as children so it works a little different
  if (cmsComponent === 'layout.markdown') {
    return <MarkdownWrapper id={id}>{item.content}</MarkdownWrapper>;
  }

  const Component = componentMap[cmsComponent];

  if (!Component) {
    console.error(`Field type ${cmsComponent} not supported`);
    return null;
  }

  return <Component id={id} props={item} />;
};
